import React from 'react';
import styles from './Text.module.css';
import phone1 from '../assets/Phone1.png';
import phone2 from '../assets/Phone2.png';
import phone3 from '../assets/Phone3.png';

function Text() {
  return (
    <section className={styles.Text}>
      <div className={styles.banner}>
        <h2 className={styles.sectionTitle}>Skriv tekster med kunstig intelligens</h2>
      </div>
      <div className={styles.content}>
        <div className={styles.cardLow}>
            <h3>Tidligere lagret notat</h3>
            <img src={phone1} alt="Tidligere lagret notat" className={styles.cardImageLow} />
        </div>
        <div className={styles.card}>
          <img src={phone2} alt="Snakk til appen" className={styles.cardImage} />
          <h3>Snakk til appen</h3>
        </div>
        <div className={styles.cardLow}>
        <h3>La KI skrive teksten</h3>
          <img src={phone3} alt="La KI skrive teksten" className={styles.cardImageLow} />
        </div>
      </div>
      <div className={styles.description}>
        <h3>Hvordan det fungerer</h3>
        <p>
          Man setter på opptak og "prater" inn i møtet eller etter et møte eller en befaring.
          Når man er ferdig genererer programmet ved hjelp av kunstig intelligens (KI) en ryddig og tydelig
          liste eller rapport, der irrelevant samtale ryddes vekk. Den genererte teksten kan man redigere,
          lese inn mer tekst i, be om å sette inn dato eller annet man kommer på, og så legge inn i eget
          fagsystem eller sende på e-post til mottakere.
        </p>
      </div>
    </section>
  );
}

export default Text;
